'use strict';

var _ = require('lodash');

module.exports = {
  getIcon: function (options) {

    var id = options.id;
    var customClassName = options.type ? options.type + '-marker' : 'gcp-marker';
    var safeType = options.type.toLowerCase();
    safeType = safeType === 'checkpoint' ? 'chp' : safeType;
    var html = '<span class="id">' + id + '</span><span class="'+safeType+'">'+safeType.toUpperCase()+'</span>';

    options = _.extend(options, {
      iconSize: [15,15],
      className: options.className + ' ' + customClassName,
      html: html
    });

    // // needs to ALWAYS have the `base` className
    if (options.className.indexOf('gcp-marker') === -1 && options.className.indexOf('checkpoint-marker') === -1) {
      options.className = options.className && 'gcp-marker ' + options.className || 'gcp-marker';
    }

    return L.divIcon(options);
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/gcp/lib/MarkerUtil.js